module.exports = __webpack_public_path__ + "img/exh-image02.7605a6ec.jpg";